import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-configuration-help',
    templateUrl: './configuration-help.component.html'
})
export class ConfigurationHelpComponent {
}
